import React from "react";

const animData = require("./data/LoginAnim").default;

import { ActivityIndicator, View, Dimensions } from "react-native";

import Animation from "./LotieView";
import AppConfig from "../../../config/AppConfig";
import Header from "../common/header/index";
import Footer from "../common/footer/index";

import { isWeb } from "../../../helpers/utils";
import appStyles from "../../appStyles";
const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");

export default class AnimationPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
    this.animation = null;
    this.userAvatar = props.controller.state
      ? props.controller.state.picture
      : null;

    this.state = {
      isLoading: false,
      data: null,
    };
  }

  componentDidMount = () => {
    this.retrieveDataIfNeeded();
  };

  retrieveDataIfNeeded() {
    if (isWeb) {
      const src = animData.login.data;

      if (src != null) {
        fetch(src)
          .then((response) => response.json())
          .then((imageData) => {
            this.setState({
              data: imageData,
            });
            this.startAnimation();
          });
      }
    } else {
      this.startAnimation();
    }
  }

  startAnimation() {
    setTimeout(() => {
      if (this.animation != null) this.animation.play();
    }, 300);
  }

  render() {
    const { isLoading, data } = this.state;

    const animStyle = {
      width: Math.min(WIDTH, AppConfig.MAX_WIDTH),
      transform: [{ translateY: -95 }],
    };

    const src = isWeb ? data : animData.login.data;

    return (
      <View style={appStyles.container}>
        <Header
          title=""
          avatar={this.userAvatar}
          controller={this.controller}
          showMore
        />

        {isLoading ? (
          <View>
            <ActivityIndicator size="large" color="#5fab77" />
          </View>
        ) : (
          <View style={appStyles.scrollView}>
            <Animation
              ref={(ref) => {
                this.animation = ref;
              }}
              style={animStyle}
              source={src}
            />
          </View>
        )}

        {this.controller.hasNavigation() ? null : (
          <View style={appStyles.footerOptions}>
            <Footer controller={this.controller} selectedPage="" />
          </View>
        )}
      </View>
    );
  }
}
